import { render, staticRenderFns } from "./RentsReportList.vue?vue&type=template&id=00f0f126&scoped=true&"
import script from "./RentsReportList.vue?vue&type=script&lang=js&"
export * from "./RentsReportList.vue?vue&type=script&lang=js&"
import style0 from "./RentsReportList.vue?vue&type=style&index=0&id=00f0f126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0f126",
  null
  
)

export default component.exports